import React from 'react';
import classNames from 'classnames';

const ExpandableListChildBase = ({ children, active }) => (
  <li className={classNames({ active })}>{children}</li>
);
const ExpandableListChildLink = ({ active, href, children }) => (
  <ExpandableListChildBase active={active}>
    <a href={href}>{children}</a>
  </ExpandableListChildBase>
);
const ExpandableListChildButton = ({ active, onClick, children }) => (
  <ExpandableListChildBase active={active}>
    <button type="button" onClick={onClick}>
      {children}
    </button>
  </ExpandableListChildBase>
);

const ExpandableListChild = {
  Link: ExpandableListChildLink,
  Button: ExpandableListChildButton,
  Base: ExpandableListChildBase,
};

export default ExpandableListChild;
